/**
 * Root Layout Component
 * 
 * Wraps all routes with FCM integration and provides Outlet for nested routes
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import FCMIntegration from '../FCMIntegration';
import HomeTabBar from '../HomeTabBar';

const RootLayout = () => {
  return (
    <FCMIntegration>
      <Outlet />
      {/* Rendered once here, inside RouterProvider, so it can react to location
          changes. It self-hides on every route that is not a home section. */}
      <HomeTabBar />
    </FCMIntegration>
  );
};

export default RootLayout;
